<template>
  <div>
    <Aguarde :show="showAguarde"></Aguarde>
    <Loader :loading="httpSend">
      <div class="mb-2"><label>Filtros:</label>
        <div class="row border-bottom border-secondary">
          <div class="col-xl-4 col-md-6 col-sm-6"><label class="card-radio-label mb-3">
            <input type="radio" name="pay-method"
                   @change="alterFilter(true)"
                   id="pay-methodoption3"
                   :value="true"
                   v-model="filtro.confirmado"
                   v-bind:checked="filtro.confirmado"
                   class="card-radio-input">
            <div class="card-radio"><i class="fas fa-user-check font-size-24 text-success align-middle mr-2"></i>
              <span>Confirmados</span>
            </div>
          </label>
          </div>
          <div class="col-xl-4 col-md-6 col-sm-6"><label class="card-radio-label mb-3">
            <input type="radio" name="pay-method"
                   id="pay-methodoption1"
                   @change="alterFilter(false)"
                   v-bind:checked="filtro.aguardando"
                   :value="true"
                   v-model="filtro.aguardando"
                   class="card-radio-input">
            <div class="card-radio">
              <i class="fas fa-user-clock font-size-24 text-dark align-middle mr-2"></i>
              <span>Aguardando Confirmação</span>
            </div>
          </label>
          </div>
        </div>
      </div>
      <div v-if="filtro.aguardando">
        <div v-show="!list_usuario_temp.length || list_usuario_temp.length < 1" role="alert" aria-live="polite"
             aria-atomic="true" class="alert alert-primary text-center">
          Sem usuários aguardando confirmação
        </div>
        <div v-for="g in list_usuario_temp" :key="g.tus_codigo" class="row">
          <div class="col-md-12 mb-3 border-bottom border-secondary">
            <div class="row">
              <div class="col-md-3">
                <b-form-group label="CPF">
                  <h6 class="mb-0">{{ g.tus_cpfcnpj | VMask('###.###.###-##') }}</h6>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group label="E-mail">
                  <h6 class="mb-0">{{ g.tus_mail }}</h6>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="Status">
                  <span v-show="g.tus_status==='E'" class="badge badge-success font-size-12">E-mail enviado</span>
                  <span v-show="g.tus_status==='X'" class="badge badge-danger font-size-12">Erro no e-mail</span>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <b-form-group label="Inclusão">
                  <h6 class="mb-0">{{ g.log_datainclusao | formatDateHora }}</h6>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group class="mt-2">
                  <button type="button" @click="reenviaConfirmacao(g)"
                          title="Reenviar e-mail de confirmação"
                          class="btn btn-info btn-sm mr-2 mb-2">
                    <i class="bx bx-mail-send"></i> Reenviar e-mail
                  </button>
                  <button type="button" @click="detalhe('aguardando',g)" title="Editar Usuário"
                          class="btn btn-outline-primary btn-sm mr-2 mb-2">
                    <i class="bx bxs-user-detail"></i> Detalhes
                  </button>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group class="mt-2">
                  <button type="button" @click="openLinkConfirmacao(g)"
                          title="Link para confirmação"
                          class="btn btn-dark btn-sm mr-2 mb-2">
                    <i class="bx bx-link"></i> Link de confirmação
                  </button>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="filtro.confirmado">
        <div v-show="!list_usuarios.length || list_usuarios.length < 1" role="alert" aria-live="polite"
             aria-atomic="true" class="alert alert-primary text-center">
          Sem usuários confirmados
        </div>

        <div class="row border-bottom border-secondary mb-1">
          <div class="col-12">
            <b-form @submit.prevent="listUsuarios">
              <div class="row">
                <div class="col-md-3">
                  <b-form-group
                      label="Nome"
                      label-for="pes_nome">
                    <input
                        id="pes_nome"
                        v-model="filtro.pes_nome"
                        type="text"
                        maxlength="120"
                        class="form-control"
                        placeholder=" ">
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group
                      label="CPF">
                    <the-mask class="form-control" v-model="filtro.pes_cpfcnpj"
                              :mask="['###.###.###-##']"/>
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group label="Status" label-for="aut_status">
                    <select id="aut_status"
                            @change="listUsuarios()"
                            v-model="filtro.aut_status"
                            class="custom-select" type="text">
                      <option value="">Todos</option>
                      <option value="A">Ativo</option>
                      <option value="I">Inativo</option>
                    </select>
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group label="Tipo" label-for="aut_access">
                    <select id="aut_access"
                            @change="listUsuarios()"
                            v-model="filtro.aut_access"
                            class="custom-select" type="text">
                      <option value="">Todos</option>
                      <option value="P">Usuário</option>
                      <option value="A">Administrador</option>
                    </select>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <b-form-group label="Usuários por Página" label-for="nota_pagina">
                    <select id="nota_pagina"
                            @change="listUsuarios()"
                            v-model="filtro.nota_pagina"
                            class="custom-select" type="text">
                      <option value="10">10/Pág.</option>
                      <option value="30">30/Pág.</option>
                      <option value="50">50/Pág.</option>
                      <option value="80">80/Pág.</option>
                      <option value="100">100/Pág.</option>
                      <option value="200">200/Pág.</option>
                      <option value="500">500/Pág.</option>
                      <option value="800">800/Pág.</option>
                      <option value="1000">1000/Pág.</option>
                    </select>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group label="'" class="text-white">
                    <button type="submit"
                            class="btn btn-label btn-primary mr-3"><i
                        class="bx bx-search label-icon"></i>
                      Consultar
                    </button>
                  </b-form-group>
                </div>
              </div>
            </b-form>
          </div>
        </div>

        <div v-for="g in list_usuarios" :key="g.pes_cpfcnpj" class="row">
          <div class="col-md-12 mb-3 border-bottom border-secondary">
            <div class="row">
              <div class="col-md-3">
                <b-form-group class="mb-1" label="CPF">
                  <h6 class="mb-0">
                    <router-link tag="a"
                                 :to="{name: 'admin-pessoas-usuarios-detalhe', params: {tipo: 'confirmados', hash: g.aut_hash}}">
                      {{ g.pes_cpfcnpj | VMask('###.###.###-##') }}
                    </router-link>
                  </h6>
                </b-form-group>
              </div>
              <div class="col-md-9">
                <b-form-group class="mb-1" label="Nome">
                  <h6 class="mb-0">{{ g.pes_nome }}</h6>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <b-form-group class="mb-1" label="E-mail">
                  <h6 class="mb-0">{{ g.pes_mail }}</h6>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group class="mb-1" label="Tipo/Status">
                  <h6 class="mb-0">
                    <span v-show="g.aut_access==='P'" class="badge badge-info font-size-12 mr-2">Usuário</span>
                    <span v-show="g.aut_access==='A'" class="badge badge-danger font-size-12 mr-2">Administrador</span>
                    <span v-show="g.aut_status==='I'" class="badge badge-dark font-size-12">Inativo</span>
                    <span v-show="g.aut_status==='A'" class="badge badge-success font-size-12">Ativo</span>
                  </h6>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group class="mb-1 text-white" label="'">
                  <button type="button" @click="detalhe('confirmados', g)" title="Editar Usuário"
                          class="btn btn-primary btn-sm mr-0 mb-0">
                    <i class="bx bxs-user-detail"></i> Detalhes
                  </button>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>
        <div v-show="list_usuarios && list_usuarios.length > 0" class="row">
          <div class="col-lg-12">
            <paginate
                v-model="filtro.pagina"
                :page-count="total_paginas"
                :page-range="3"
                :margin-pages="3"
                :click-handler="proximaPagina"
                :prev-text="'Página anterior'"
                :next-text="'Próxima página'"
                :prev-link-class="'page-link'"
                :next-link-class="'page-link'"
                :page-link-class="'page-link'"
                :container-class="'pagination pagination-rounded justify-content-center mt-4'"
                :page-class="'page-item'">
            </paginate>
          </div>
        </div>
      </div>
    </Loader>
  </div>
</template>
<script>
import Loader from "@/components/widgets/loader";
import Aguarde from "@/components/widgets/aguarde";
import {TheMask} from 'vue-the-mask'
import Paginate from 'vuejs-paginate'
import {listUsuarios} from "@/api/admin/pessoas/pessoas";
import {setReenviaConfirmacao} from "@/api/login/auth";

export default {
  components: {
    Loader,
    Aguarde,
    TheMask,
    Paginate
  },
  props: {
    aguardando: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      list_usuario_temp: [],
      list_usuarios: [],
      total_paginas: 0,
      filtro: {
        aguardando: false,
        confirmado: true,
        pagina: 1,
        nota_pagina: "10",
        pes_nome: "",
        pes_cpfcnpj: "",
        aut_status: "",
        aut_access: ""
      },
      showAguarde: false,
      httpSend: false,
    };
  },
  created() {
    this.alterFilter(this.aguardando)
  },
  methods: {
    listUsuarios() {
      this.httpSend = true;
      listUsuarios(this.filtro).then(result => {
        if (this.filtro.aguardando) {
          this.list_usuario_temp = result.dados;
        } else {
          this.total_paginas = result.dados.paginas;
          this.list_usuarios = result.dados.empresas;
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    proximaPagina(pageNum) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      this.filtro.pagina = pageNum;
      this.listUsuarios()
    },
    alterFilter(tipo) {
      if (tipo) {
        this.filtro.confirmado = true;
        this.filtro.aguardando = false;
      } else {
        this.filtro.confirmado = false;
        this.filtro.aguardando = true;
      }
      this.listUsuarios();
    },
    detalhe(tipo, u) {
      let hash = (tipo === 'aguardando') ? u.tus_codigo : u.aut_hash;
      this.$router.push({
        name: "admin-pessoas-usuarios-detalhe",
        params: {tipo: tipo, hash: hash}
      })
    },
    reenviaConfirmacao(u) {
      this.showAguarde = true;
      const dados = {
        usuario: u,
        dominio: window.location.origin,
      };
      setReenviaConfirmacao(dados).then(result => {
        if (result.status) {
          this.listUsuarios();
          this.$toast.success(result.mensagem);
        } else {
          this.$toast.error(result.mensagem)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.showAguarde = false;
      })
    },
    openLinkConfirmacao(g) {
      let routeData = this.$router.resolve({name: 'confirmacao'});
      window.open(routeData.href + 'confirmacao/' + g.tus_codigo, '_blank');
    },
  }
};
</script>

